import { Card, Empty, Table } from 'antd';
import { AddCircle20Regular, ServerMultiple20Regular } from "@fluentui/react-icons";
import { ColumnsType } from "antd/lib/table/interface";
import * as React from "react";
import { Link } from "react-router-dom";
import { NavItem, NavLink } from 'reactstrap';
import { DEFAULT_IP_NAME_NUMBER, MEMBERS_PORTAL } from "../../accounts/Consts";
import { SOCAN_CUSTOMER_NAME } from "../Consts";
import FooterContainer from "../../core/components/footer/FooterContainer";
import FormBoxMenuContainer from "../../core/components/formBoxMenu/FormBoxMenuContainer";
import { ComponentsHelper } from "../../core/services/ComponentHelper";
import { IMenuItem } from "../../core/types/IMenuItem";
import { ILookupDictionary } from "../../lookup/types/ILookupDictionary";
import { ACCOUNT_NO, CURRENTLY_VIEWING_AS, MEMBER_CREATE_NEW_APPLICATION, MEMBER_MY_APPLICATIONS, MEMBER_MY_CASES, MEMBER_OPEN_NEW_CASE, WELCOME, HOME_PAGE_BACKGROUND_IMAGE_SOCAN, HOME_PAGE_BACKGROUND_IMAGE_SPANISH_POINT, NO_DATA, SORT_DESCENDING, SORT_ASCENDING, CANCEL_SORTING, PAGE_ANCHOR_MY_CASES, AFFILIATED_WITH, NOT_AFFILIATED, PERFORMING_RIGHTS_LABEL, REPRODUCTION_RIGHTS_LABEL, IPI_NO } from "../../membersportal/Consts";
import { IApplication } from "../../membersportal/types/IApplication";
import { ICase } from "../../membersportal/types/ICase";
import { IViewAsAccessRequest } from "../../membersportal/types/IViewAsAccessRequest";
import { parseDateType } from "../../membersportal/util/dateHelpers";
import { setCurrentPage } from "../../redux/reducers/HomeReducer";
import { hideModal, showModal, updateComment } from "../../redux/reducers/ModalReducer";
import { getAllUsageFilenamesFromDistribution, getCWRAckHWM, getManualJobDataSources, getMenuItemsThunk, getScheduledJob, getUsageFilenames, triggerManualJob, upsertScheduledJobAsync } from "../../redux/thunks/HomeThunks";
import { IActiveAccordion } from "../../redux/types/IActiveAccordion";
import { IEnableModulesConfigurationParametersItem } from "../../redux/types/IEnableModulesConfigurationParameterItem";
import IMembersPortalComponentDataItem from "../../redux/types/IMembersPortalComponentDataItem";
import IRepertoireComponentDataItem from "../../redux/types/IRepertoireComponentDataItem";
import { IResultsPerPage } from "../../redux/types/IResultsPerPage";
import IShortCutKeys from "../../redux/types/IShortCutKeys";
import { IContributorSearchQuery } from "../../repertoire/types/IContributorSearchQuery";
import { IContributorSearchResult } from "../../repertoire/types/IContributorSearchResult";
import { IRepertoireField } from "../../repertoire/types/IRepertoireField";
import { IAckHWMState } from "../types/IAckHWMState";
import IHomeComponentData from "../types/IHomeComponentData";
import { IJobSearchResult } from "../types/IJobSearchResult";
import { IJobSearchState } from "../types/IJobSearchState";
import { IDataSourceBase } from "../types/JobParameterControls/IDataSource";
import HomeModal from "./homeModal/HomeModal";
import JobSearchResultsViewContainer from "./jobSearchResultsView/JobSearchResultsViewContainer";
import { MembersPortalService } from '../../redux/services/MembersPortalService';
import { MembersPortalRoles } from '../../redux/types/MembersPortalRoles';
import ITooltip from '../../repertoire/components/Tooltip/IToolTip';
import { PERMISSION_MESSAGE } from '../../repertoire/Consts';
import InfoToggle from '../../membersportal/sharedComponents/button/InfoToggle';
import { IMembersPortalPathInfo } from '../../membersportal/types/IMembersPortalPathInfo';
import { handlePageAnchorNavigation, hasAnyValidValue } from '../../util/tools';
import ResponsiveRenderer from '../../core/components/responsiveRenderer/ResponsiveRenderer';
import { ReadOnlyDivTable } from '../../dataingestion/components/readOnlyDivTable/ReadOnlyDivTable';
import { IAccountSocietyAffiliation } from '../../membersportal/types/IAccountSocietyAffiliation';
import { CURRENT_USER_NAME_KEY } from '../../redux/services/AccountSessionStorage';
import { getViewAsAccessRequestsThunk } from '../../redux/thunks/MembersPortalThunks';
import { ApplicantAccess } from '../../membersportal/ApplicantAccess';

interface IHomePageProps {
    componentData: IHomeComponentData;
    lookups: ILookupDictionary;
    users: string[];
    jobSearchState: IJobSearchState;
    jobSearchResults: IJobSearchResult[];
    currentPage: IMenuItem;
    setCurrentPage: typeof setCurrentPage;
    enableModules?: IEnableModulesConfigurationParametersItem[];
    defaultActiveAccordions?: IActiveAccordion[];
    resultsPerPage?: IResultsPerPage[];
    resultsPerModalPage?: number;
    currentModalPage: number;
    manualJobs: () => void;
    displayModal: boolean;
    modalContent: string;
    modalComponentInstance: string;
    modalProps: any;
    displayModalCloseButton: boolean;
    modalTitle: string;
    showModal: typeof showModal;
    hideModal: typeof hideModal;
    indexOfFirstResult?: number;
    indexOfLastResult?: number;
    resetPagination: (repertoireSection: string) => void;
    updatePagination: (indexOfFirstResult: number, indexOfLastResult: number, resultsPerModalPage: number, currentPage: number, repertoireSection: string) => void;
    updateModalComment: typeof updateComment;
    modalMessage: string;
    manualJobType: string;
    manualJobParameters: any;
    triggerManualJob: typeof triggerManualJob;
    getUsageFilenames:typeof getUsageFilenames;
    getScheduledJob: typeof getScheduledJob;
    upsertScheduledJobAsync:typeof upsertScheduledJobAsync; 
    getAllUsageFilenamesFromDistribution:typeof getAllUsageFilenamesFromDistribution;
    cwrAckHWM: IAckHWMState[];
    getCWRAckHWM: typeof getCWRAckHWM;
    fetchManualJobDataSources: typeof getManualJobDataSources
    manualJobDataSources: { [key: string]: IDataSourceBase }
    getPaymentRunIDs: () => void;
    paymentRunIDs: any;
    portalType: string;
    client: string;
    username?: string;
    currentUserNameNumber?: string;
    currentUserAccountNumber?: string;
    searchViewData?: IRepertoireComponentDataItem;
    dataSource?: string;
    searchResultsTableData?: IRepertoireComponentDataItem;
    searchContributors?: (
        query: IContributorSearchQuery
    ) => void;
    contributorsSearchResults?: IContributorSearchResult[];
    searchSuccessful?: boolean;
    searchViewResultsPerPage?: number;
    searchViewCurrentPage?: number;
    loadMembersPortalFromPath: (pathInfo: IMembersPortalPathInfo, currentUserNameNumber: string, location: Location) => void;
    updateManualJobParams: (params: any) => void;
    currentViewAsUserName: string;
    shortCutKeys: IShortCutKeys[];
    myApplications: IApplication[];
    myCases: ICase[];
    membersPortalSearchResultsTableData: IMembersPortalComponentDataItem;
    isCRMIntegrationEnabled: boolean;
    powerPortalURL: string;
    customerDatePreference: string;
    viewAsAccessRequests?: IViewAsAccessRequest[];
    customerTimeZonePreference: string;
    enableMemberNumber?: boolean;
    updateCMUContributors?: (cmuContributors: any[], modalIndex?: number) => void;
    modalIndex?: number;
    customerTerritory?:string;
    customer?: string;  
    refreshMyCases: () => void;
    refreshMyApplications: () => void;
    accountSocietyAffiliation?: IAccountSocietyAffiliation;
    getCurrentUserSocietyAffiliation: () => void;
	getMenuItems: typeof getMenuItemsThunk;
	getViewAsAccessRequests: typeof getViewAsAccessRequestsThunk;
}

interface IHomePageState {
    isLoading: boolean;
}

export class HomePage extends React.Component<IHomePageProps, IHomePageState>{
    viewData = {};
    private hasRefreshedOnMount = false;
    constructor(props: IHomePageProps) {
        super(props);
        this.state = {
            isLoading: true
        }
    }

    private hydrateViewDataAndStopLoading = (): void => {
        const { portalType, componentData } = this.props;

        const fields =
            portalType === MEMBERS_PORTAL
                ? componentData?.MembersPortalHomePage?.fields
                : componentData?.JobSearchView?.fields;

        if (!fields || fields.length === 0) {
            return;
        }

        fields.forEach((item) => {
            this.viewData[item.name] = item.data;
        });

        if (this.state.isLoading) {
            this.setState({ isLoading: false });
        }
    };


    async componentDidMount() {
        const {
            portalType,
            isCRMIntegrationEnabled,
            refreshMyCases,
            refreshMyApplications,
            getCurrentUserSocietyAffiliation,
            getMenuItems,
            getViewAsAccessRequests,
            username
        } = this.props;

        this.hydrateViewDataAndStopLoading();

        if (portalType === MEMBERS_PORTAL) {
            getCurrentUserSocietyAffiliation();
            await getViewAsAccessRequests(username);
            await getMenuItems(portalType);
        }

        if (portalType === MEMBERS_PORTAL && isCRMIntegrationEnabled) {
            refreshMyCases();
            refreshMyApplications();
            this.hasRefreshedOnMount = true;
        }

        setTimeout(() => handlePageAnchorNavigation(), 0);
    }

    componentDidUpdate(prevProps: IHomePageProps) {
        const { componentData, portalType, isCRMIntegrationEnabled, refreshMyCases, refreshMyApplications } = this.props;

        const prevFields =
            prevProps.portalType === MEMBERS_PORTAL
                ? prevProps.componentData?.MembersPortalHomePage?.fields
                : prevProps.componentData?.JobSearchView?.fields;

        const currentFields =
            portalType === MEMBERS_PORTAL
                ? componentData?.MembersPortalHomePage?.fields
                : componentData?.JobSearchView?.fields;

        if (prevFields !== currentFields) {
            this.hydrateViewDataAndStopLoading();
        }

        if (portalType === MEMBERS_PORTAL && isCRMIntegrationEnabled &&
            (
                prevProps.isCRMIntegrationEnabled !== isCRMIntegrationEnabled ||
                prevProps.portalType !== portalType ||
                prevProps.currentPage?.link !== this.props.currentPage?.link
            ))
        {
            if (!this.hasRefreshedOnMount) {
                refreshMyCases();
                refreshMyApplications();
            }
            this.hasRefreshedOnMount = false;
        }

        setTimeout(() => handlePageAnchorNavigation(), 0);
    }

    getMyApplicationsColumns = () =>{
        const { membersPortalSearchResultsTableData, customerDatePreference, client } = this.props;
        
        if (membersPortalSearchResultsTableData) {

            if (membersPortalSearchResultsTableData && membersPortalSearchResultsTableData.fields) {

                let filteredFields = membersPortalSearchResultsTableData.fields.filter(
                    (field: IRepertoireField) =>
                        field.componentInstance === MEMBER_MY_APPLICATIONS
                );

                let orderedFields = ComponentsHelper.orderFieldsBySpecificField(filteredFields, "order");
                if (!orderedFields && orderedFields.length > 0) {
                    orderedFields = filteredFields
                }                

                let columns: ColumnsType<IApplication> = orderedFields.filter(x => !x.hidden).map((field, index) => {
                    switch (field.name) {                                              
                        case 'applicationId':
                            return {
                                title: field.data,
                                dataIndex: field.name,
                                width: '7em',
                                key: `${field.name}`,
                                sorter: (a, b) => isNaN(a[field.name]) ? a[field.name].localeCompare(b[field.name]) : a[field.name] - b[field.name],
                                render: (value, record, index) => {
                                    return <NavItem>
                                        <NavLink data-testid={`home-application-${record.applicationId}-link`} tag={Link} to={{ pathname: `${"/myForms"}`, aboutProps: { guid: record.guid, memberType: record.memberType, client: this.props.client } }} onClick={() => this.props.setCurrentPage(`${"/myForms?guid="}${record.guid}`)}>{record.applicationId}</NavLink>
                                    </NavItem>;
                                }
                            }
                        case 'contact':
                            return {
                                title: field.data,
                                dataIndex: field.name,
                                width: '8em',
                                key: `${field.name}`,
                                sorter: (a, b) => isNaN(a[field.name]) ? a[field.name].localeCompare(b[field.name]) : a[field.name] - b[field.name],
                                render: (value, record, index) => {
                                    return record.name;
                                }
                            }
                        case 'submittedDateTime':
                            return {
                                title: field.data,
                                dataIndex: field.name,
                                width: '7em',
                                key: `${field.name}`,
                                sorter: (a, b) => isNaN(a[field.name]) ? a[field.name].localeCompare(b[field.name]) : a[field.name] - b[field.name],
                                render: (value, record, index) => {
                                    return parseDateType(record.submittedDateTime, customerDatePreference + ' HH:mm:ss');
                                }
                            }
                        case 'lastModifiedDateTime':
                            return {
                                title: field.data,
                                dataIndex: field.name,
                                width: '7em',
                                key: `${field.name}`,
                                render: (value, record, index) => {
                                    return parseDateType(record.lastModifiedDate, customerDatePreference + ' HH:mm:ss');
                                }
                            }
                        case 'status':
                            return {
                                title: field.data,
                                dataIndex: field.name,
                                width: '7em',
                                key: `${field.name}`,
                                render: (value, record, index) => {
                                    return record.status;
                                }
                            }                          
                        default:
                            return {
                                title: field.data, dataIndex: field.name,
                                width: '6em',
                                key: `${field.name}`,
                                align: 'center',
                                sorter: (a, b) => isNaN(a[field.name]) ? a[field.name].localeCompare(b[field.name]) : a[field.name] - b[field.name],
                                render: (value) => value !== null ? <div key={`${value}_${index}`}>{value}</div> : null
                            }
                    }
                })
                return columns;
            }
        }
    }

    getMyCasesColumns = () => {
        const { membersPortalSearchResultsTableData, customerDatePreference  } = this.props;

        if (membersPortalSearchResultsTableData) {

            if (membersPortalSearchResultsTableData && membersPortalSearchResultsTableData.fields) {

                let filteredFields = membersPortalSearchResultsTableData.fields.filter(
                    (field: IRepertoireField) =>
                        field.componentInstance === MEMBER_MY_CASES
                );

                let orderedFields = ComponentsHelper.orderFieldsBySpecificField(filteredFields, "order");

                if (!orderedFields && orderedFields.length > 0) {
                    orderedFields = filteredFields
                }
               
                let columns: ColumnsType<ICase> = orderedFields.filter(x => !x.hidden).map((field, index) => {
                    switch (field.name) {
                        case 'ticketNumber':
                            return {
                                title: field.data,
                                dataIndex: field.name,
                                width: '7em',
                                key: `${field.name}`,
                                sorter: (a, b) => isNaN(a[field.name]) ? a[field.name].localeCompare(b[field.name]) : a[field.name] - b[field.name],
                                render: (value, record, index) => {
                                    return <NavItem>
                                        <NavLink data-testid={`home-case-${record.ticketNumber}-link`} tag={Link} to={{ pathname: `${"/cases/openNewCase"}`, aboutProps: { guid: record.guid }}}>{record.ticketNumber}</NavLink>
                                    </NavItem>;
                                }
                            }
                        case 'title':
                            return {
                                title: field.data,
                                dataIndex: field.name,
                                width: '8em',
                                key: `${field.name}`,
                                sorter: (a, b) => isNaN(a[field.name]) ? a[field.name].localeCompare(b[field.name]) : a[field.name] - b[field.name],
                                render: (value, record, index) => {
                                    return record.title;
                                }
                            }
                        case 'caseType':
                            return {
                                title: field.data,
                                dataIndex: field.name,
                                width: '7em',
                                key: `${field.name}`,
                                sorter: (a, b) => isNaN(a[field.name]) ? a[field.name].localeCompare(b[field.name]) : a[field.name] - b[field.name],
                                render: (value, record, index) => {
                                    return record.caseType;
                                }
                            }
                        case 'caseOrigin':
                            return {
                                title: field.data,
                                dataIndex: field.name,
                                width: '7em',
                                key: `${field.name}`,
                                render: (value, record, index) => {
                                    return record.caseOrigin;
                                }
                            }
                        case 'submittedDateTime':
                            return {
                                title: field.data,
                                dataIndex: field.name,
                                width: '7em',
                                key: `${field.name}`,
                                render: (value, record, index) => {
                                    return parseDateType(record.submittedDateTime, customerDatePreference + ' HH:mm:ss');
                                }
                            }
                        case 'lastModifiedDateTime':
                            return {
                                title: field.data,
                                dataIndex: field.name,
                                width: '7em',
                                key: `${field.name}`,
                                render: (value, record, index) => {
                                    return parseDateType(record.lastModifiedDate, customerDatePreference + ' HH:mm:ss');
                                }
                            }
                        case 'status':
                            return {
                                title: field.data,
                                dataIndex: field.name,
                                width: '7em',
                                key: `${field.name}`,
                                render: (value, record, index) => {
                                    return record.status;
                                }
                            }                                                
                        default:
                            return {
                                title: field.data, dataIndex: field.name,
                                width: '6em',
                                key: `${field.name}`,
                                align: 'center',
                                sorter: (a, b) => isNaN(a[field.name]) ? a[field.name].localeCompare(b[field.name]) : a[field.name] - b[field.name],
                                render: (value) => value !== null ? <div key={`${value}_${index}`}>{value}</div> : null
                            }
                    }
                })
                return columns;
            }
        }
    }

	private getCrmFields = (componentInstance: string): IRepertoireField[] => {
		const fields = this.props.membersPortalSearchResultsTableData?.fields || [];

		const filteredFields = fields.filter(
			(field: IRepertoireField) => field.componentInstance === componentInstance && !field.hidden
		);

		const orderedFields = ComponentsHelper.orderFieldsBySpecificField(filteredFields, "order");

		return orderedFields?.length ? orderedFields : filteredFields;
	};

	private renderCrmActionButton = (
		title: string,
		label: string,
		pathname: string,
		hasPermission: boolean,
		testId: string
	): JSX.Element => (
		<div className="newJobButton" title={title}>
			{hasPermission ? (
                <div className="IconTextButton">
                    <NavLink tag={Link} to={{ pathname, aboutProps: { type: "new" } }}>
                        <AddCircle20Regular className="icon" aria-hidden="true" />
                    </NavLink>
                    <NavLink className="crmActionText" tag={Link} to={{ pathname, aboutProps: { type: "new" } }} data-testid={testId}>
                        {label}
                    </NavLink>
                </div>
			) : (
				<ITooltip tooltipContent={PERMISSION_MESSAGE} showTooltip={true} placement="top">
					<span style={{ display: "inline-block" }}>
						<div className="IconTextButton disabled">
							<AddCircle20Regular
								className="icon disabled"
								aria-hidden="true"
							/>
							{label}
						</div>
					</span>
				</ITooltip>
			)}
		</div>
	);

	private getCrmTableLocale = () => ({
		emptyText: (
			<Empty
				image={Empty.PRESENTED_IMAGE_SIMPLE}
				description={this.viewData[NO_DATA]}
			/>
		),
		triggerDesc: this.viewData[SORT_DESCENDING],
		triggerAsc: this.viewData[SORT_ASCENDING],
		cancelSort: this.viewData[CANCEL_SORTING],
	});

    private renderCrmSection = (
        title: string,
        actionTitle: string,
        actionLabel: string,
        actionPath: string,
        hasPermission: boolean,
        actionTestId: string,
        columns: any[],
        dataSource: any[],
        componentInstance: string,
        titleFieldName: string,
        pageAnchor?: string
    ): JSX.Element => {
        const fields = this.getCrmFields(componentInstance);

        return (
            <div className="row" data-page-anchor={pageAnchor}>
                <div className="col-md-12">
                    <Card className="crmIntegrationSection">
                        <div className='crmIntegrationHeader'>
                            <div className="crmIntegrationTitle">
                                <ServerMultiple20Regular className="icon" aria-hidden="true" />
                                <span className="title">{title}</span>
                            </div>

                            {this.renderCrmActionButton(
                                actionTitle,
                                actionLabel,
                                actionPath,
                                hasPermission,
                                actionTestId
                            )}
                        </div>

                        <ResponsiveRenderer
                            desktop={
                                <div className="tableContainer">
                                    <Table
                                        columns={columns}
                                        dataSource={dataSource}
                                        rowClassName={() => "editable-row"}
                                        size="middle"
                                        onChange={() => { }}
                                        className="parent-table"
                                        tableLayout="fixed"
                                        locale={this.getCrmTableLocale()}
                                    />
                                </div>
                            }
                            tablet={
                                <ReadOnlyDivTable
                                    fields={fields}
                                    dataSource={dataSource}
                                    titleFieldName={titleFieldName}
                                    emptyText={this.viewData[NO_DATA]}
                                    customerDatePreference={this.props.customerDatePreference}
                                    pagination={true}
                                    viewData={this.viewData}
                                />
                            }
                        />
                    </Card>
                </div>
            </div>
        );
    };

    renderCRMIntegration = (): JSX.Element => {
		const { myApplications, myCases, isCRMIntegrationEnabled } = this.props;

		if (!isCRMIntegrationEnabled) {
			return null;
		}

        const hasPermissionMyForms = ApplicantAccess.isAccessibleToNewApplicants("myForms") || ["myForms", "forms"].some(permissionKey => MembersPortalService.hasPermissionForMenu(
            permissionKey,
            MembersPortalRoles.FullAccess
        ));

        const hasPermissionMyCases = ApplicantAccess.isAccessibleToNewApplicants("cases") || MembersPortalService.hasPermissionForMenu(
            "myCases",
            MembersPortalRoles.FullAccess
        );

		return (
			<div className="crmIntegration">
				{this.renderCrmSection(
					this.viewData[MEMBER_MY_APPLICATIONS],
					"New Application",
					this.viewData[MEMBER_CREATE_NEW_APPLICATION],
					"/myForms",
					hasPermissionMyForms,
					"home-create-application-link",
					this.getMyApplicationsColumns(),
					myApplications,
					MEMBER_MY_APPLICATIONS,
					"applicationId"
				)}

				{this.renderCrmSection(
					this.viewData[MEMBER_MY_CASES],
					"New Case",
					this.viewData[MEMBER_OPEN_NEW_CASE],
					"/cases/openNewCase",
					hasPermissionMyCases,
					"home-create-case-link",
					this.getMyCasesColumns(),
					myCases,
					MEMBER_MY_CASES,
					"ticketNumber",
					PAGE_ANCHOR_MY_CASES
				)}
			</div>
		);
	};

    renderMatchingMaintenanceHomePage = () => {
        const { displayModal, customerDatePreference, customerTimeZonePreference, customerTerritory } = this.props;
        if (this.renderMatchingMaintenanceHomePage) {
            document.title = "Matching Engine";
        }
        return (
            <div className="container pageContent">
                <FormBoxMenuContainer />
                <div className="row">
                    <JobSearchResultsViewContainer customerTimeZone={customerTimeZonePreference} customerTerritory={customerTerritory} />
                </div>
                {displayModal ? (<HomeModal {...this.props} />) : null}
            </div>
        );
    }

    renderMembersPortalHomePage = () => {
        const { currentViewAsUserName, currentUserNameNumber, currentUserAccountNumber, viewAsAccessRequests, customer, componentData, lookups, loadMembersPortalFromPath, accountSocietyAffiliation } = this.props;

		const username = sessionStorage.getItem(CURRENT_USER_NAME_KEY);
        const hasValidViewAsIdentity = hasAnyValidValue(currentUserNameNumber, currentUserAccountNumber);
        const viewInfo = hasValidViewAsIdentity ? "" : "hidding";

        const infoToggleHeaderField = componentData?.MembersPortalHomePage?.fields
            .find(x => x.name === 'infoToggleHeader');

        const infoToggleHtmlField = componentData?.MembersPortalHomePage?.fields
            .find(x => x.name === 'infoToggleHTML');


        const renderInfoToggle = (
            <InfoToggle
                headerTextItem={infoToggleHeaderField}
                htmlTextItem={infoToggleHtmlField}
                currentUserNameNumber={currentUserNameNumber}
                lookupValues={lookups}
                loadMembersPortalFromPath={loadMembersPortalFromPath}
            />
        )

        const backgroundImage = customer == SOCAN_CUSTOMER_NAME ? HOME_PAGE_BACKGROUND_IMAGE_SOCAN : HOME_PAGE_BACKGROUND_IMAGE_SPANISH_POINT;
       
        let viewAsName = hasValidViewAsIdentity ? currentViewAsUserName : "";

        if (!viewAsName && viewAsAccessRequests?.length) {
            const defaultUser = viewAsAccessRequests.find(
                (item) => item.defaultAccess === true && item.status === "Approved",
            );

            if (defaultUser) {
                viewAsName = defaultUser.ipName;
            }
        }

        let viewAsAccountNumber = currentUserAccountNumber;
        let viewAsIpiNumber = currentUserNameNumber;

        if (viewAsName && viewAsAccessRequests?.length) {
            const activeViewUser = viewAsAccessRequests.find(
                (item) => item.ipName === viewAsName && item.status === "Approved",
            );

            if (activeViewUser) {
                viewAsAccountNumber = activeViewUser.accountNumber;
                viewAsIpiNumber = activeViewUser.ipiNumber;
            }
        }

        const showSocietyAffiliation = accountSocietyAffiliation?.active === true;

        const prSocietyAffiliationText = accountSocietyAffiliation?.isPRAffiliated ? `${this.viewData[AFFILIATED_WITH]} ${accountSocietyAffiliation.prSocietyCode}` : this.viewData[NOT_AFFILIATED];

        const mrSocietyAffiliationText = accountSocietyAffiliation?.isMRAffiliated ? `${this.viewData[AFFILIATED_WITH]} ${accountSocietyAffiliation.mrSocietyCode}` : this.viewData[NOT_AFFILIATED];

        return (
            <div className="pageContent ">
                <div className="membersPortalContainer">
                    <img className="membersPortalBgImg" src={ backgroundImage } />

                    <div className="container">
						<Card className="membersPortalPanel">
							<div className="row">
								<div className='portalMainInfo'>
									<h3 className="cardSubText">{this.viewData[WELCOME]}</h3>
									<h3 className="cardMainText">{username}</h3>
                                </div>
								<div className={`cardSideText ${viewInfo}`}>
									<h3 className="sideDesc">{this.viewData[CURRENTLY_VIEWING_AS]}</h3>
									<h3 className="sideViewName">{viewAsName}</h3>
                                </div>
                                <div className={`cardSideText accountInformation ${viewInfo}`}>
                                    <div className="accountNumber">
                                        <span className="accountNumberLabel">{this.viewData[ACCOUNT_NO]}</span> <b>{viewAsAccountNumber}</b>
                                    </div>
                                    {hasAnyValidValue(viewAsIpiNumber) && (
                                        <div className="ipiNumber">
                                            <span className="ipiNumberLabel">{this.viewData[IPI_NO]}</span> <b>{viewAsIpiNumber}</b>
                                        </div>
                                    )}
                                </div>
                                {showSocietyAffiliation && (
                                    <>
                                        <div className="portalSocietyAffiliation cardSideText">
                                            <div className="societyAffiliationLabel">
                                                {this.viewData[PERFORMING_RIGHTS_LABEL]}
                                            </div>
                                            <div className="societyAffiliationValue">
                                                {prSocietyAffiliationText}
                                            </div>
                                        </div>

                                        <div className="portalSocietyAffiliation cardSideText">
                                            <div className="societyAffiliationLabel">
                                                {this.viewData[REPRODUCTION_RIGHTS_LABEL]}
                                            </div>
                                            <div className="societyAffiliationValue">
                                                {mrSocietyAffiliationText}
                                            </div>
                                        </div>
                                    </>
                                )}
							</div>
						</Card>

                        {renderInfoToggle}

                        <div className='menuItems'>
							<FormBoxMenuContainer />
						</div>

                        {this.renderCRMIntegration() }
                    </div>

                    <FooterContainer />
                </div>
            </div>
        );
    }

    render() {
        const { currentPage, setCurrentPage, portalType } = this.props;
        const { isLoading } = this.state;

        if(!isLoading){
            if (!currentPage || currentPage.link !== '/') {
                setCurrentPage('/');
            }
            if (portalType === MEMBERS_PORTAL) {
                return this.renderMembersPortalHomePage()
            }
            else {
                return this.renderMatchingMaintenanceHomePage()
            }
        }
        return <div></div>
    }
}
